import { useMutation } from '@apollo/client';
// Api
import { CONNECTED_SOCIAL_ACCOUNTS } from 'api/auth/queries';
import { UNLINK_SOCIAL_MEDIA_CONNECTION } from 'api/social-media-connections/mutations';
// Types
import {
  UnlinkSocialMediaConnection,
  UnlinkSocialMediaConnectionVariables,
} from 'api/social-media-connections/types/UnlinkSocialMediaConnection';

export const useUnlinkSocialMediaConnection = () => {
  return useMutation<
    UnlinkSocialMediaConnection,
    UnlinkSocialMediaConnectionVariables
  >(UNLINK_SOCIAL_MEDIA_CONNECTION, {
    refetchQueries: [{ query: CONNECTED_SOCIAL_ACCOUNTS }],
    awaitRefetchQueries: true,
  });
};
